import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpService } from './http.service';
import { exhaustMap, mergeMap, tap } from 'rxjs/operators';
import { HomePageCategoryModel, HomePageModel, Product, BannerModel } from '@shared/models';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class CategoryProductsService {
    private httpService = inject(HttpService);

    category$ = new BehaviorSubject<HomePageCategoryModel | null>(null);
    productsByCategory$ = new BehaviorSubject<Product[] | null>(null);
    sliders$ = new BehaviorSubject<BannerModel[] | false | null>(null);
    event$ = new Subject();

    init = false;

    dispatch(): void {
        if (!this.init) {
            this.initialize();
        }
        this.event$.next(true);
        this.init = true;
    }

    private initialize() {
        this.event$
            .pipe(
                exhaustMap(() => {
                    return this.httpService.getHomeData().pipe(
                        tap((data: HomePageModel) => {
                            this.category$.next(data.category);
                            this.sliders$.next(data.sliders);
                        }),
                        mergeMap(() => this.httpService.getProductsByCategory(this.category$.value?.slug)),
                        tap((products: Product[]) => {
                            const productsWithImages = products.map((product: Product) => ({
                                ...product,
                                image: {
                                    url: environment.serverUrl + `api/public/product/catalogue/image/${product.patternName}`,
                                },
                            }));

                            this.productsByCategory$.next(productsWithImages);
                        }),
                    );
                }),
            )
            .subscribe();
    }
}
